module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN327_1792055494.c06a6b2d.png";